import { Menu, Transition } from "@headlessui/react";
import { Fragment, ReactNode } from "react";
import { useUserDataStore } from "../../stores/user";
import Button from "../Shared/Button";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import imgPlaceholder from "../../assets/ImgPlaceholder.svg";
import SettingsIcon from "../Icons/SettingsIcon";
import ProfileIcon from "../Icons/ProfileIcon";
import LogoutIcon from "../Icons/LogoutIcon";
const Dropdown = ({ children }: { children?: ReactNode }) => {
  const { userData, reset } = useUserDataStore();
  const handleLogout = () => {
    Cookies.remove("accessToken");
    reset();
  };
  return (
    <div className="relative ">
      <Menu as="div" className="relative inline-block">
        <div>
          <Menu.Button className="inline-flex w-full justify-center  focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75">
            {children}
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute md:top-11 md:right-0 right-5 mt-2 min-w-[285px] w-full origin-top-right  divide-black/5 rounded-[7px] border-slate bg-white border border-opacity-20  text-left shadow-lg ring-1 divide-y -top-4 pt-5 pb-3 ring-black/5 focus:outline-none z-50 ">
            <div className="flex items-center gap-3 pb-4 border-b border-black/5 px-4">
              <img
                src={userData?.img_url ?? imgPlaceholder}
                className="rounded-full size-14 object-cover border border-black/20"
                alt=""
              />
              <div className="w-full">
                <h1 className="font-semibold text-burntBlack mb-0.5">
                  {userData?.firstName} {userData?.lastName}
                </h1>
                <p className="text-lightGray text-xs truncate max-w-[200px]">
                  {userData?.email}
                </p>
              </div>
            </div>
            <div className="space-y-6 px-4 py-5">
              <Link to="/settings" className="flex gap-2 cursor-pointer">
                <SettingsIcon />
                <p className="text-sm text-black">Settings</p>
              </Link>
              {userData?.role === "student" && (
                <div className="flex gap-2 cursor-pointer">
                  <ProfileIcon />
                  <Link to="/my-profile" className="text-sm text-black">
                    My Profile
                  </Link>
                </div>
              )}
            </div>
            <div className="px-4 py-5">
              <button onClick={handleLogout} className="flex gap-2">
                <LogoutIcon />
                <p className="text-sm text-[#FF0000]">Log Out</p>
              </button>
            </div>
            <div className="pt-2">
              {userData?.role === "admin" && (
                <Link
                  to={`/dashboard/students`}
                  className="font-bold text-slate mt-5 w-full"
                >
                  <Button
                    variant="primary"
                    className="max-w-[200px] w-full mx-auto !text-sm !rounded !h-[42px]"
                  >
                    Dashboard{" "}
                  </Button>
                </Link>
              )}
              {userData?.role === "sales" && (
                <Link
                  to={`/sales/dashboard/students`}
                  className="font-bold text-slate mt-5 w-full"
                >
                  <Button
                    variant="primary"
                    className="max-w-[200px] w-full mx-auto !text-sm !rounded !h-[42px]"
                  >
                    Dashboard{" "}
                  </Button>
                </Link>
              )}
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};

export default Dropdown;
